import React from 'react';
import { CloseX } from './vd/LineArt';

const RenovationPopup = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="renovation-popup-title"
    >
      <div
        className="absolute inset-0 bg-vd-text/40 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-vd-bg rounded-2xl shadow-2xl max-w-md w-full p-6 sm:p-8 vd-fade border border-vd-soft">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-vd-muted hover:text-vd-text p-2"
          aria-label="Zapri"
        >
          <CloseX size={18} />
        </button>

        <h3
          id="renovation-popup-title"
          className="font-serif text-2xl sm:text-3xl text-vd-text mb-3"
        >
          Spletna stran je v prenovi
        </h3>

        <p className="text-sm sm:text-base text-vd-muted leading-relaxed">
          Val Dotika raste. Trenutno pripravljamo novo spletno izkušnjo, več
          vsebin in mrežo podpore za mamice. Nekateri deli strani se zato še
          spreminjajo. Hvala, ker si z nami. 🤍
        </p>
      </div>
    </div>
  );
};

export default RenovationPopup;
